import { initialStateOptions } from '@/utils/pagination-utils';
import moment from 'moment';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const statusOptions = [
  {
    id: 'TODAS',
    description: 'Todas',
    value: null,
  },
  {
    id: 'PENDENTES',
    description: 'Pendentes',
    value: () => '(situacaoEntrega = \'PENDENTE\')',
  },
  {
    id: 'ATRASADAS',
    description: 'Atrasadas',
    value: () => `(situacaoEntrega = 'PENDENTE' and dataPrevisaoEntrega < ${moment().format('YYYY-MM-DD')})`,
  },
  {
    id: 'RECEBIDAS',
    description: 'Recebidas',
    value: () => '(situacaoEntrega = \'ENTREGUE\')',
  },
];

const statusOptionsGestaoEntregaV2 = [
  {
    id: 'PENDENTES',
    description: 'Pendentes',
    value: () => '(situacaoEntrega in (\'PENDENTE\', \'FATURADO\', \'FATURADO_PARCIAL\', \'ENTREGUE_PARCIAL\'))',
    valueSaldo: () => null,
  },
  {
    id: 'PENDENTES_PARCIAIS',
    description: 'Parciais',
    value: () => '(situacaoEntrega = \'ENTREGUE_PARCIAL\')',
    valueSaldo: () => null,
  },
  {
    id: 'ENTREGA_ATRASADA',
    description: 'Atrasadas',
    value: () => '(situacaoEntrega != \'ENTREGUE\')',
    valueSaldo: () => `(isAtrasado is true and dataPrevisaoEntrega <= ${moment().format('YYYY-MM-DD')})`,
  },
  {
    id: 'ESSA_SEMANA',
    description: 'Entregas da semana',
    value: () => {
      const startOfWeek = moment().startOf('week').format('YYYY-MM-DD');
      const endOfWeek = moment().endOf('week').format('YYYY-MM-DD');
      return `(situacaoEntrega in ('PENDENTE', 'FATURADO', 'FATURADO_PARCIAL', 'ENTREGUE_PARCIAL') and dataPrevisaoEntregaSaldo >= ${startOfWeek} and dataPrevisaoEntregaSaldo <= ${endOfWeek})`;
    },
    valueSaldo: null,
  },
  {
    id: 'ENTREGUES',
    description: 'Entregues',
    value: () => '(situacaoEntrega = \'ENTREGUE\')',
    valueSaldo: null,
  },
  {
    id: 'TODAS',
    description: 'Todas',
    value: null,
    valueSaldo: null,
  },
];

const isGestaoEntregaEnabled = process.env.VUE_APP_GESTAO_ENTREGA_V2_ENALED === 'true';

const state = {
  searchText: null,
  statusOptions: isGestaoEntregaEnabled ? statusOptionsGestaoEntregaV2 : statusOptions,
  selectedStatus: {
    id: 'PENDENTES',
    description: 'Pendentes',
    value: () => {
      if (isGestaoEntregaEnabled) {
        return '(situacaoEntrega in (\'PENDENTE\', \'FATURADO\', \'FATURADO_PARCIAL\', \'ENTREGUE_PARCIAL\'))';
      }
      return '(situacaoEntrega = \'PENDENTE\')';
    },
  },
  empresa: null,
  localEntrega: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  dataInicial: null,
  dataFinal: null,
  grupo: [],
  solicitante: [],
  fornecedor: [],
  listOptions: initialStateOptions('dataPrevisaoEntrega'),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
